import React from "react";
import pin from "../../style/images/location.svg";
import { useOrganization } from "../../context/OrganizationContext";

interface UpperSectionProps {
  shouldLocationDisplayed: boolean;
}

const UpperSection: React.FC<UpperSectionProps> = ({
  shouldLocationDisplayed,
}) => {
  const { organizationData, loading } = useOrganization();

  if (loading) {
    return (
      <div className="bg-customLightBlue text-white px-1 h-[229px] pt-24 rounded-b-[2.5rem] ps-3">
        <div className="custom-font animate-pulse bg-gray-300 h-6 w-36 mb-2 ms-4"></div>
        <div className="custom-font animate-pulse bg-gray-300 h-8 w-48 mb-4 ms-4"></div>
        {shouldLocationDisplayed ? (
          <div className="flex ps-4 pt-2">
            <div className="animate-pulse bg-gray-300 h-5 w-5 rounded-full me-2"></div>
            <div className="location-font animate-pulse bg-gray-300 h-6 w-48 ps-2"></div>
          </div>
        ) : (
          <div className="location-font animate-pulse bg-gray-300 h-6 w-48 ps-2"></div>
        )}
      </div>
    );
  }

  return (
    <div className="bg-customLightBlue text-white px-1 h-[229px] pt-24 rounded-b-[2.5rem] ps-3">
      <div className="custom-font">{organizationData?.title && "Welcome to"}</div>
      <div className="custom-font">{organizationData?.title}</div>
      {shouldLocationDisplayed ? (
        <div className="flex ps-4 pt-2">
          {organizationData?.title && <img src={pin} alt="location" />}
          <div className="location-font ps-2">{organizationData?.address}</div>
        </div>
      ) : (
        <div className="location-font ps-2">Thank you for booking</div>
      )}
    </div>
  );
};

export default UpperSection;
